import apiClient from "../apiInstance.js";
import { IVR_URLS } from "../../services/apiConfig.js";
import { POLICY_ERRORS } from "../../common/constants/ivrModule/policyConstants.js";

export const getIvrDistributionPolicy = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.GET_IVR_POLICY);
        const policies = response.data.policy?.value || [];
        const responsePolicies = policies.map((policy) => ({
            id: policy.id,
            policyname: policy.name,
            offerExpiresAfterSeconds: policy.offerExpiresAfterSeconds,
            etag: policy.etag,
            modeKind: policy.mode.kind,
            minConcurrentOffers: policy.mode.minConcurrentOffers,
            maxConcurrentOffers: policy.mode.maxConcurrentOffers,
            bypassSelectors: policy.mode.bypassSelectors,
        }));
        return responsePolicies;
    } catch (error) {
        console.error(POLICY_ERRORS.GET_IVR_POLICY, error);
        throw error;
    }
};

export const addEditIvrDistributionPolicy = async (policyToSave) => {
    try {
        const response = await apiClient.post(
            IVR_URLS.ADD_IVR_POLICY,
            policyToSave
        );
        return response.data;
    } catch (error) {
        console.error(POLICY_ERRORS.ADD_POLICY_ERROR, error);
        throw error;
    }
};

export const deleteIvrDistributionPolicy = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.DELETE_IVR_POLICY);
        return response.data;
    } catch (error) {
        console.error(POLICY_ERRORS.DELETE_POLICY_ERROR, error);
        throw error;
    }
};